<template>
  <v-container class="setting-page" fluid>
    <v-card class="pa-4">
      <v-card-title>⚙️ Settings</v-card-title>
      <v-card-text>
        <v-switch v-model="notifications" label="Enable Notifications" />
        <v-switch v-model="darkMode" label="Dark Mode" />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'SettingView',
  data() {
    return {
      notifications: true,
      darkMode: false
    }
  }
}
</script>

<style scoped>
.setting-page {
  padding: 16px;
}
</style>